import intl from 'react-intl-universal'

export default {
  type: 'interstitial_link',
  title: `Interstitial`,
  icon: `external-link-square`,
  template: `
      <div 
        contenteditable="false"
        feature-obj="feature"
        org-index="orgIndex"
      >
        <p class="pb-2">[
          <a contenteditable="false"  href="{{feature.url}}" target="_blank" title="{{feature.content}}">
            {{feature.content}}
          </a>
        ]</p>
      </div>`,

  propertyTemplate: `<div ng-form="interstitial">
        <div class="form-group" ng-class="{'has-danger': !interstitial.url.$valid}">
          <label>${intl.get(
            'blocks.interstitialLink.labels.url'
          )} <sup class="color-danger" title="required">*</sup></label>
          <input
            type="text"
            name="url"
            required
            class="form-control"
            ng-model="feature.url"
            ng-blur="feature.url = feature.url.length && feature.url.indexOf('http')!=0 && feature.url.indexOf('//')!=0 ? '//' + feature.url : feature.url"
            placeholder="http://example.com" />
        </div>
        <div class="form-group" ng-class="{'has-danger': !interstitial.text.$valid }">
          <label>${intl.get(
            'blocks.interstitialLink.labels.text'
          )} <sup class="color-danger" title="required">*</sup></label>
          <input
            type="text"
            name="text"
            required
            smart-quote-handler
            class="form-control"
            ng-model="feature.content"
            placeholder="Link Text" />
        </div>
      </div>`,
  initialInflation: function () {
    return {
      type: 'interstitial_link',
      url: '',
      content: '',
    }
  },
  onPaste: function (elem) {
    const anchor = elem.find('a')
    return {
      type: 'interstitial_link',
      url: anchor.attr('href'),
      content: anchor.text(),
    }
  },
  openPropertyTemplateOnAdd: true,
}
